import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import replace from "string-replace-to-array";
import FavourSnippet from "@components/FavourSnippet";
import Portal from "@components/Portal";
import clsx from "clsx";
import {PostTypeMap} from "../../../utils/helpers";
import ResultAlert from "./ResultAlert";
import ResetButton from "./ResetButton";

function SearchResult({data, resetHandler}) {
    const [cards, setCards] = useState([]);
    const isLoad = useSelector(({searchReducer}) => searchReducer.isLoad);
    const wishList = useSelector(({wishListReducer}) => wishListReducer.wishList);
    // eslint-disable-next-line max-len
    const {
        searchNoResults, searchPostType, alertIndex, alertThumbnail, alertUrl, alertTitle, alertText, alertBtnText,
    } = useSelector(({rootReducer}) => rootReducer.baseSettings);
    let wishlist = document.getElementById("js-lg-wishlist");

    /**
     * Inserts an alert card on a specified spot.
     * Or doesn't if the alertIndex is not a valid number.
     */
    useEffect(() => {
        const index = Number(alertIndex);

        if (data && data.length) {
            // eslint-disable-next-line max-len
            if (!Number.isNaN(index) && alertIndex !== "" && alertUrl !== "" && alertTitle !== "" && alertBtnText !== "") {
                const modifiedCards = [...data];
                modifiedCards.splice(index, 0, "alert");
                setCards(modifiedCards);
            } else {
                setCards(data);
            }
        } else {
            // Unset cards to render the 'No results found' box
            setCards([]);
        }
    }, [data, alertIndex, isLoad]);

    if (data && !data.length && searchNoResults) {
        const searchNoResultsArray = replace(
            searchNoResults,
            /(reset)/g,
            <ResetButton resetText={"reset"} resetHandler={resetHandler}/>,
        );
        return (
            <div role="alert">
                {typeof searchNoResultsArray !== "undefined" && searchNoResultsArray.map((item, key) => {
                    if (typeof item === "string") {
                        return (
                            <span key={key} dangerouslySetInnerHTML={{__html: item}}/>
                        );
                    }
                    return item;
                })}
            </div>
        );
    }

    return (
        <>
            {wishlist && (
                <Portal Component={FavourSnippet} container={wishlist}/>
            )}

            {
                cards.length > 0 && !isLoad ? <ul className={clsx(`job-cards`, !isLoad && `resultCardsAnimation`)}>
                    {cards.map((result, index) => {
                        if (result === "alert") {
                            return (
                                <ResultAlert
                                    key={index}
                                    index={index}
                                    total={cards.length}
                                    alertThumbnail={alertThumbnail}
                                    alertUrl={alertUrl}
                                    alertTitle={alertTitle}
                                    alertText={alertText}
                                    alertBtnText={alertBtnText}
                                />
                            );
                        }

                        /**
                         * Get either a component from the fieldTypeMap object or fallback to the default.
                         * See utils/helpers for PostTypeMap
                         * @type {*|string}
                         */
                        const PostTypeComponent = PostTypeMap[searchPostType] ?? 'default';

                        return <PostTypeComponent
                            index={index}
                            result={result}
                            total={cards.length}
                            wishlist={wishList[result.ID]}
                        />;
                    })}
                </ul> : !isLoad && <div className={"job-no-results"}>
                    Geen resultaten gevonden. Probeer het later nog eens.
                </div>
            }
        </>
    );
}

export default SearchResult;
